"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataObjectSortableColumns = void 0;
var DataObjectSortableColumns;
(function (DataObjectSortableColumns) {
    DataObjectSortableColumns["dataObjectId"] = "dataObjectId";
    DataObjectSortableColumns["processDefinitionId"] = "processDefinitionId";
    DataObjectSortableColumns["processModelId"] = "processModelId";
    DataObjectSortableColumns["processInstanceId"] = "processInstanceId";
    DataObjectSortableColumns["flowNodeInstanceId"] = "flowNodeInstanceId";
    DataObjectSortableColumns["value"] = "value";
    DataObjectSortableColumns["createdAt"] = "createdAt";
})(DataObjectSortableColumns = exports.DataObjectSortableColumns || (exports.DataObjectSortableColumns = {}));
//# sourceMappingURL=DataObjectInstance.js.map